if (!customElements.get('tbp-category-grid')) {
  customElements.define('tbp-category-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) { this.activate(tab); return; }
        const sub = event.target.closest('[data-sub]');
        if (sub && this.contains(sub)) this.filter(sub);
      });
      this.addEventListener('shopify:block:select', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab) this.activate(tab);
      });
    }
    activate(tab) {
      this.querySelectorAll('[data-tab]').forEach(button => {
        const active = button === tab;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.querySelectorAll('.pg-panel').forEach(panel => {
        panel.classList.toggle('active', panel.id === tab.dataset.tab);
      });
    }
    filter(chip) {
      const panel = chip.closest('.pg-panel');
      if (!panel) return;
      const handle = chip.dataset.sub;
      panel.querySelectorAll('[data-sub]').forEach(button => {
        const active = button === chip;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      let visible = 0;
      panel.querySelectorAll('.pg-card').forEach(card => {
        const subs = ' ' + (card.dataset.subs || '') + ' ';
        const show = handle === 'all' || subs.indexOf(' ' + handle + ' ') !== -1;
        card.hidden = !show;
        if (show) visible++;
      });
      const empty = panel.querySelector('.pg-empty-filter');
      if (empty) empty.hidden = visible > 0;
      const link = panel.querySelector('.pg-view-all');
      if (link && chip.dataset.url) {
        link.href = chip.dataset.url;
        link.textContent = 'Shop all ' + chip.dataset.label + ' →';
      }
    }
  });
}
